import {gql} from "@apollo/client";

export const ShiftConfig = {
    shiftConfigs: "shiftConfigs"
}

export const GET_SHIFT_CONFIGS = gql`
query  shiftConfigPage(
    $filter: String
    $page: Int
    $pageSize: Int
    $search: String
    $sort: String
) {
    ${ShiftConfig.shiftConfigs}(
        filter: $filter
        page: $page
        pageSize: $pageSize
        search: $search
        sort: $sort
    ) {
        items {
            externalReferenceCode
            shiftConfigId
            name
            code
            flexibleString
            timeStartString
            timeEndString
            breakTimeEndString
            breakTimeStartString
            checkInBeforeString
            checkOutBeforeString
            flexibleTotalHour
            totalWork
        }
        page
        pageSize
        totalCount
    }
}`

